import { PreguntaDTO } from "@DTOS";
import { Exporter } from "../Exporter";

export class ExporterNormal implements Exporter {
    public puedeExportar(_pregunta: PreguntaDTO): boolean {
        return true;
    }

    public exportar(respuestas: any, respuesta: any[], pregunta: PreguntaDTO): void {
        const item = pregunta.items.find(itemDTO => itemDTO.id === respuesta[0]);

        if (item == null) {
            return;
        }

        respuestas[pregunta.texto] = item.texto;
    }
}
